import { useAuthStore } from '@/store/auth';
import { isSiteUser } from '@/lib/siteDashboard';

export function useSiteDashboard(): boolean {
  return useAuthStore((s) => isSiteUser(s.user));
}
